import demo from './demo';
import local from './local';
import dev from './dev';
import staging from './staging';
import prod from './prod';


const CONFIGS = {
  prod,
  staging,
  local,
  demo,
  dev,
};

// Vite mode -> application environment.
// `vite build` uses mode "production" (prod), `vite` uses "development" (dev).
// VITE_APP_ENV (e.g. from .env.<mode> or the shell) has priority over the mode.
const MODE_TO_ENV = {
  production: 'prod',
  development: 'dev',
};

export const resolveAppEnv = (mode, explicitEnv) => {
  const env = explicitEnv || MODE_TO_ENV[mode] || mode;
  return CONFIGS[env] ? env : 'dev';
};

export const APP_ENV = resolveAppEnv(import.meta.env.MODE, import.meta.env.VITE_APP_ENV);

const appConfig = CONFIGS[APP_ENV];
export { appConfig as default };
